import { useMemo, useCallback } from 'react';

import { useLocalStorage } from './useStorage';

export default function useLocalStorageJSON<T extends {}>(
  localStorageKey: string,
  initialValue: T,
): [T, (value: T) => void, () => T | undefined] {
  const [data, setData, readData] = useLocalStorage(localStorageKey, JSON.stringify(initialValue));

  const parsedData: T = useMemo(() => {
    try {
      return JSON.parse(data) as T;
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
      return initialValue;
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setJSONData = useCallback((value: T) => setData(JSON.stringify(value)), []);

  const getJSONData = useCallback(() => {
    try {
      return JSON.parse(readData()) as T;
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }

    return undefined;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [parsedData, setJSONData, getJSONData];
}
